import API from 'services/API';

export default function saveEmail(email) {
  let requestData = new FormData();
  requestData.append('email', email);

  return API.request({
    method: 'POST',
    url: '/profile/updateEmail',
    data: requestData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    mapper: function (data = {}) {
      return data;
    },
  });
}
